<script setup>
import { computed } from 'vue';
import { useDisplay } from 'vuetify';

const emit = defineEmits(['close']);

const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
    fullHeight: {
        type: Boolean,
        default: false,
    },
    cardColor: {
        type: String,
        default: 'surface',
    },
    cardVariant: {
        type: String,
        default: 'elevated',
    },
});

const { smAndDown } = useDisplay();

const height = computed(() => {
    if (props.fullHeight && !smAndDown.value) {
        return window.innerHeight - 48;
    }

    return null;
});

const fullscreen = computed(() => smAndDown.value);
</script>

<template>
    <v-dialog
        :fullscreen="fullscreen"
        :height="height"
        :max-width="fullscreen ? undefined : 960"
        :scrollable="true"
        :model-value="show"
        :close-on-back="true"
        @update:model-value="emit('close')"
    >
        <v-card :color="cardColor" :variant="cardVariant">
            <v-card-title v-if="!!$slots.title" class="tw-pl-[24px]">
                <slot name="title"></slot>
            </v-card-title>
            <v-card-text v-if="!!$slots.content" class="tw-pt-2">
                <slot name="content"></slot>
            </v-card-text>
            <v-card-actions v-if="!!$slots.footer" class="tw-p-6 tw-py-2">
                <slot name="footer"></slot>
            </v-card-actions>
            <slot name="append"></slot>
        </v-card>
    </v-dialog>
</template>
